var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPolygonSketch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 3.83333C1.5 4.45217 1.74583 5.04566 2.18342 5.48325C2.621 5.92083 3.21449 6.16667 3.83333 6.16667C4.45217 6.16667 5.04566 5.92083 5.48325 5.48325C5.92083 5.04566 6.16667 4.45217 6.16667 3.83333C6.16667 3.21449 5.92083 2.621 5.48325 2.18342C5.04566 1.74583 4.45217 1.5 3.83333 1.5C3.21449 1.5 2.621 1.74583 2.18342 2.18342C1.74583 2.621 1.5 3.21449 1.5 3.83333Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8333 3.83333C17.8333 4.45217 18.0792 5.04566 18.5168 5.48325C18.9543 5.92083 19.5478 6.16667 20.1667 6.16667C20.7855 6.16667 21.379 5.92083 21.8166 5.48325C22.2542 5.04566 22.5 4.45217 22.5 3.83333C22.5 3.21449 22.2542 2.621 21.8166 2.18342C21.379 1.74583 20.7855 1.5 20.1667 1.5C19.5478 1.5 18.9543 1.74583 18.5168 2.18342C18.0792 2.621 17.8333 3.21449 17.8333 3.83333Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 20.1667C1.5 20.7855 1.74583 21.379 2.18342 21.8166C2.621 22.2542 3.21449 22.5 3.83333 22.5C4.45217 22.5 5.04566 22.2542 5.48325 21.8166C5.92083 21.379 6.16667 20.7855 6.16667 20.1667C6.16667 19.5478 5.92083 18.9543 5.48325 18.5168C5.04566 18.0792 4.45217 17.8333 3.83333 17.8333C3.21449 17.8333 2.621 18.0792 2.18342 18.5168C1.74583 18.9543 1.5 19.5478 1.5 20.1667Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8333 20.1667C17.8333 20.7855 18.0792 21.379 18.5168 21.8166C18.9543 22.2542 19.5478 22.5 20.1667 22.5C20.7855 22.5 21.379 22.2542 21.8166 21.8166C22.2542 21.379 22.5 20.7855 22.5 20.1667C22.5 19.5478 22.2542 18.9543 21.8166 18.5168C21.379 18.0792 20.7855 17.8333 20.1667 17.8333C19.5478 17.8333 18.9543 18.0792 18.5168 18.5168C18.0792 18.9543 17.8333 19.5478 17.8333 20.1667Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1667 12C13.1667 12.6188 13.4125 13.2123 13.8501 13.6499C14.2877 14.0875 14.8812 14.3333 15.5 14.3333C16.1188 14.3333 16.7123 14.0875 17.1499 13.6499C17.5875 13.2123 17.8333 12.6188 17.8333 12C17.8333 11.3812 17.5875 10.7877 17.1499 10.3501C16.7123 9.9125 16.1188 9.66666 15.5 9.66666C14.8812 9.66666 14.2877 9.9125 13.8501 10.3501C13.4125 10.7877 13.1667 11.3812 13.1667 12Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.83333 6.16666V17.8333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.16667 3.83334H17.8333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.16667 20.1667H17.8333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 9.66666L19 6.16666",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 14.3333L19 17.8333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygonSketch);
export default __webpack_public_path__ + "static/media/polygonSketch.aa7967c7e893a7c893a8318e91fd380f.svg";
export { ForwardRef as ReactComponent };